module.exports = __webpack_public_path__ + "img/repair_icon.f7747649.svg";